// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1Y3li","wrapper-nopadding":"wrapper-nopadding__rW_Bv","loading":"loading__1jdtd","error":"error__3K5p8","table-loading":"table-loading__1HW2J","empty-val":"empty-val__3a8oi","panelheader-tools":"panelheader-tools__3FAzU","propsPanels":"propsPanels__3j0Zf","new":"new__2RXC2","marginLm":"marginLm__1kezy","marginRm":"marginRm__1uyfG","fullWidth":"fullWidth__1wyjQ","fullHeight":"fullHeight__rYHOD","noData":"noData__MImV9","packets":"packets__1Ghlo","panels":"panels__sX4Zx"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayPacketStat/styles.scss
// module id = 2264
// module chunks = 1